<template>
    <div id="control_panel">
        <div id="control_panel_portrait">
            <img v-if="portrait == 'Default'" src="./img/portrait_default.svg" />
            <img v-else-if="portrait == 'Aye'" src="./img/portrait_aye.svg" />
            <img v-else-if="portrait == 'Ria'" src="./img/portrait_ria.svg" />
            <img v-else-if="portrait == 'Devyn'" src="./img/portrait_devyn.svg" />
            <img v-else-if="portrait == 'Hailey'" src="./img/portrait_hailey.svg" />
            <img v-else-if="portrait == 'Reece'" src="./img/portrait_reece.svg" />
            <img v-else-if="portrait == 'Dylan'" src="./img/portrait_dylan.svg" />
            <img v-else-if="portrait == 'Skylar'" src="./img/portrait_skylar.svg" />
            <!-- <img id="voice_line" src="./img/voice_line.svg" /> -->
        </div>
        <div id="control_panel_text">
            <span class="control_panel_copy"></span>
        </div>
        <div id="control_panel_next" @click="next" @mousedown="button_down" @mouseup="button_up" :class="{ inactive: !control_panel_active }">
            <div id="next_button" :class="{ down: button_press, inactive: !control_panel_active }">
                <svg id="arrow" xmlns="http://www.w3.org/2000/svg" width="14" height="24" viewBox="0 0 14 24">
                    <path fill="#848484" fill-rule="evenodd" d="M2.66 0L0 2.82 8.65 12 0 21.18 2.66 24 14 12"/>
                </svg>
            </div>
        </div>
    </div>
</template>
<script>
	import * as contentful from 'contentful';
    import anime from 'animejs';
    import Typed from 'typed.js';

    export default {
        data() {
            return {
                typed_instance: null,
                portrait: '',
                button_press: false,
                type_sound: null
            }
        },
		mounted() {
            this.test = 1;
			this.typed_instance = new Typed('.control_panel_copy', {
                strings: [''],
                onComplete: () => {
                    this.type_sound.pause();
                    this.type_sound.currentTime = 0;
                }
            });
            this.type_sound = new Audio('static/audio/control_panel/typing.wav');
            this.type_sound.loop = true;
            this.type_sound.volume = 0.25;
		},
        props: ['text', 'control_panel_active'],
        watch: {
            text: function(obj) {

                if (obj.speaker) {
                    this.portrait = obj.speaker;
                } else {
                    this.portrait = 'Default';
                }

                this.typed_instance.strings = [obj.string];
                this.typed_instance.reset();
                this.type_sound.play();
            }
        },
		methods: {
			next(text) {
				this.$emit('textProgress', text);
			},
            button_down() {
                this.button_press = true;
            },
            button_up() {
                this.button_press = false;
            }
		}
    }
</script>

<style lang="scss">
    @import '../../assets/scss/variables';
    @import '../../assets/scss/mixins';

    #control_panel {
        display: flex;
        height: 200px;
        padding: 24px;
        box-sizing: border-box;

        // @media (max-width: $medium_break) {
        //     height: 16vw;
        // }
    }

    #control_panel_portrait {
        position: relative;
        width: 12%;
        background-color: $cp_blue;
        border-radius: 6px;

        img {
            @include full-center(absolute);
        }

        // #voice_line {
        //   padding-top: 100px;
        // }
    }

    #control_panel_text {
        padding: 24px;
        width: 80%;
        margin: 0 24px;
        box-sizing: border-box;
        overflow: auto;
        background-color: $cp_blue;
        border-radius: 6px;
    }

    .control_panel_copy, .typed-cursor {
        font-family: $scope_one;
        font-size: 18px;
        line-height: 32px;
        color: #777777;
    }

    #control_panel_next {
        position: relative;
        width: 10%;
        background-color: $cp_bttn;
        border-radius: 6px;
        overflow: hidden;
        cursor: pointer;
    }

    #next_button {
        position: relative;
        width: calc(100% - 5px);
        height: calc(100% - 5px);
        background-color: $cp_bttn_shadow;
        border-radius: 6px;
        transition: all 100ms;

        &.down, &.inactive {
            width: 100%;
            height: 100%;
        }

        &.inactive {
            #arrow path {
                fill: #E3E3E3;
            }
        }
    }

    #arrow {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 24px;
        height: auto;
        margin: 0 auto;
    }

    .typed-cursor {
        opacity: 1;
        -webkit-animation: blink 0.7s infinite;
        -moz-animation: blink 0.7s infinite;
        animation: blink 0.7s infinite;
    }

    @keyframes blink {
        0% { opacity:1; }
        50% { opacity:0; }
        100% { opacity:1; }
    }
</style>



// WEBPACK FOOTER //
// control_panel.vue?5ac5fa33